import { Lightning, Wrench, Megaphone } from "@phosphor-icons/react";

export default function ConstructionMarquee() {
  return (
    <div className="construction-marquee" data-testid="construction-marquee">
      <div className="construction-marquee-inner">
        {[...Array(3)].map((_, i) => (
          <span key={i} className="construction-marquee-content">
            <Wrench size={14} weight="fill" className="construction-icon" />
            <span className="construction-text">
              Website is Under Construction
            </span>
            <span className="construction-dot">•</span>
            <Lightning size={14} weight="fill" className="construction-icon" />
            <span className="construction-text">
              Exciting Features Coming Soon
            </span>
            <span className="construction-dot">•</span>
            <Megaphone size={14} weight="fill" className="construction-icon" />
            <span className="construction-text">
              Stay Tuned for Updates
            </span>
            <span className="construction-dot">•</span>
            <Wrench size={14} weight="fill" className="construction-icon" />
            <span className="construction-text">
              Website is Under Construction
            </span>
            <span className="construction-dot">•</span>
            <Lightning size={14} weight="fill" className="construction-icon" />
            <span className="construction-text">
              Exciting Features Coming Soon
            </span>
            <span className="construction-dot">•</span>
          </span>
        ))}
      </div>
    </div>
  );
}
